import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

// Browser agent keys are ingest-only — they can send telemetry but never read account data.
// They are embedded in the JS bundle and visible to anyone inspecting browser source by design.
const NR_ACCOUNT_ID = '6533080';
const NR_PROD_APPLICATION_ID = '601636145';
const NR_NON_PROD_APPLICATION_ID = '601636157';
const NR_LICENSE_KEY = 'NRJS-f4ad22acec70aad32b7';

let agentInstance: BrowserAgent | undefined;

// Reports a handled error to New Relic. No-ops when the agent was not
// initialized (localhost), so callers don't need to guard.
export function noticeError(error: Error): void {
  agentInstance?.noticeError(error);
}

export function initNewRelic(apiUrl: string, envTarget: string, dealer: string): void {
  if (window.location.hostname === 'localhost') {
    return;
  }

  const apiOrigin = new URL(apiUrl).origin;
  const applicationId =
    envTarget === 'production' ? NR_PROD_APPLICATION_ID : NR_NON_PROD_APPLICATION_ID;

  const agent = new BrowserAgent({
    init: {
      distributed_tracing: {
        enabled: true,
        allowed_origins: [apiOrigin],
      },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: NR_LICENSE_KEY,
      applicationID: applicationId,
      sa: 1,
    },
    loader_config: {
      accountID: NR_ACCOUNT_ID,
      trustKey: NR_ACCOUNT_ID,
      agentID: applicationId,
      licenseKey: NR_LICENSE_KEY,
      applicationID: applicationId,
    },
  });

  agent.setCustomAttribute('dealer', dealer);
  agentInstance = agent;
}
